import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { combineLatest, lastValueFrom, Subscription, take, forkJoin } from 'rxjs';
import { Observable } from 'rxjs';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { DynamicPageService } from '../../shared/services/dynamic-page.service';
import { FormGeneralComponent } from '../../general-page/build-page-dynamic/form-general/form-general.component';
import {
  ListDataModalInterface,
  ModalCommentInterface,
  ModalInterface,
} from '../../shared/models/components-general/modal-genearal.model';
import { ModalGeneralComponent } from '../../shared/modals/modal-general/modal-general.component';
import {
  CotStatus,
  DataQuotation,
  PageWorkflow,
} from '../../shared/models/workflow-model/workflow.model';
import { ModalGeneralCommentComponent } from '../../shared/modals/modal-general-comment/modal-general-comment.component';
import { FormGeneral, GeneralForm } from '../../shared/models/pages-model/form-general.model';
import { Toll } from '../../shared/models/components-general/menu-toll.model';
import { WorkflowService } from '../../shared/services/workflow.service';
import { environment } from '../../../environments/environment';
import { MigrationUtilityService } from '../../shared/services/migration-utility.service';
import { GeneralService } from '../../shared/services/general.service';
import { StaticPageService } from '../../shared/services/static-page.service';
import { PageGeneralComponent } from '../../general-page/build-page-dynamic/page-general/page-general.component';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { MatIconModule } from '@angular/material/icon';
import { ChangeTicketStatusComponent } from '../change-ticket-status/change-ticket-status.component';
import { TableGeneralSimpleComponent } from '../../shared/components-generals/table-general-simple/table-general-simple.component';
import { TabMenuSimple } from '../../shared/components-generals/tab-menu-simple/tab-menu-simple';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { TabRouter } from '../../shared/models/components-general/router.model';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TabMenuSimple,
    TranslateModule,
    MatButtonModule,
    MatPaginatorModule,
    PageGeneralComponent,
    LoadGeneralComponent,
    ChangeTicketStatusComponent,
    TableGeneralSimpleComponent,
    InputGeneral,
  ],
})
export class WorkflowComponent {
  @ViewChild(FormGeneralComponent) formGeneralComponent!: FormGeneralComponent;
  public viewTable = true;
  public activityForm: FormGeneral = {
    formGroups: null,
  };
  public params: Params = {};
  public cotStatus: CotStatus[] | null = null;
  public cotStatusTab: CotStatus[] | null = null;
  public taps: { id: number; descripcion: string; indexSelected: number }[] = [];
  public loadService = false;
  public ticketSearchResultPaged: any | null = null;
  public ticketPaged: any | null = null;
  public headers: { value: string; description: string }[] = [];
  public page = 1;
  public quotationStatus = 0;
  public expansion = false;
  public stateFromGrup = 0;
  public quotationId = 0;
  public statusSelected = 0;
  public subscribeArray: Subscription[] = [];
  public pageWorkflow: PageWorkflow[] = [];
  public search: FormControl = new FormControl(null);
  public tollArray: Toll[] = [
    {
      icon: 'arrow_back',
      tolltip: 'Anterior Formulario',
      type: 'scroll',
      function: 'scrollLeft',
    },
    {
      icon: 'arrow_forward',
      tolltip: 'Siguiente Formulario',
      type: 'scroll',
      function: 'scrollRight',
    },
    {
      icon: 'check',
      tolltip: 'Guardar Formulario',
      type: 'green',
      function: 'saveFrom',
    },
  ];
  public dataQuotation: DataQuotation[] = [];
  public isProd = environment.production;

  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private dynamicPageService: DynamicPageService,
    private workflowService: WorkflowService,
    private route: ActivatedRoute,
    private migrationUtilityService: MigrationUtilityService,
    private generalService: GeneralService,
    private staticPageService: StaticPageService,
  ) {
    this.readUrlParams();
    this.getData();
    const subscription = this.generalService.subscribeFormSimple(this.search).subscribe(() => {
      if (this.search.value !== null) {
        this.page = 1;
        const body = {
          quotationId: null,
          quotationStatus: [this.quotationStatus],
          catStatusStatus: ['ACTIVO'],
          quotationCotStatus: ['TERMINADA', 'COTIZACION'],
          coverType: 'DEUDOR',
          singleSearchTerm: this.search.value ?? '',
          page: this.page,
          pageSize: 10,
        };
        this.getTableIntegration(body);
      }
    });
    this.subscribeArray.push(subscription);
  }

  ngOnDestroy(): void {
    this.subscribeArray.forEach((subscription) => subscription.unsubscribe());
  }

  private async getData(): Promise<void> {
    this.loadService = true;
    const observables: Observable<CotStatus[]>[] = [this.getTabs()];
    this.getServices(observables).then((ress) => {
      if (ress) {
        // Remove specific IDs en Prduccion
        const idsToRemove = [27, 25, 28, 30, 31, 32, 29, 21, 22, 23, 24];
        const arr: CotStatus[] = ress[0].filter((item) => !idsToRemove.includes(item.iD_STATUS));
        this.cotStatusTab = arr;
        this.taps = arr.map((item, index) => ({
          id: item.iD_STATUS,
          descripcion: item.descripcion,
          indexSelected: index,
        }));
        this.cotStatus = [
          ...arr.map((item) => ({ ...item })), // clon independiente
          {
            iD_STATUS: 24,
            deS_STATUS: 'COMPRADA',
            descripcion: 'Enviar a cartera activa',
          },
        ];

        if (this.params['statusSelected']) {
          this.statusSelected = Number(this.params['statusSelected']);
        }
        this.getTableModul(this.cotStatusTab?.[this.statusSelected]?.iD_STATUS ?? 0);
      }
    });
  }

  public readUrlParams(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.params = params;
    });
  }

  public async getServices<T>(observables: Observable<T>[]): Promise<T[]> {
    return await lastValueFrom(combineLatest(observables));
  }

  // gestiona tab
  public getTabs(): Observable<any> {
    return this.workflowService.GetCotStatus();
  }

  public GetPagesByStatus(paramsInput: { status: string | number }): void {
    this.workflowService.GetPagesByStatus(paramsInput).subscribe((ress: any) => {
      if (ress) this.pageWorkflow = ress;
    });
  }

  public GetDataQuotation(tiket: number): void {
    this.dataQuotation = [];
    this.workflowService.GetDataQuotation(tiket).subscribe((ress: any) => {
      this.dataQuotation = ress;
    });
  }

  // obten la data por tab
  private async getTableModul(id: number): Promise<void> {
    this.quotationStatus = id;
    const body = {
      quotationId: null,
      quotationStatus: [this.quotationStatus],
      catStatusStatus: ['ACTIVO'],
      quotationCotStatus: [],
      coverType: 'DEUDOR',
      singleSearchTerm: '',
      page: this.page,
      pageSize: 10,
    };

    this.getTableIntegration(body);
  }

  // obtener informacion de tala
  public getTableIntegration(body: {
    quotationId: number | null;
    quotationStatus: number[];
    catStatusStatus: string[];
    quotationCotStatus: string[];
    coverType: string;
    singleSearchTerm: string;
    page: number;
    pageSize: number;
  }): void {
    this.loadService = true;
    this.workflowService
      .QuotationByfilters(body)
      .pipe(take(1))
      .subscribe((ticketSearchResultPaged: any) => {
        this.ticketSearchResultPaged = ticketSearchResultPaged;
        this.ticketPaged = ticketSearchResultPaged.items.map((item: any) => {
          return item.columns.reduce((acumulador: any, columna: any) => {
            acumulador[columna.nameData] = columna.value;
            return acumulador;
          }, {});
        });

        this.headers = ticketSearchResultPaged.items.length
          ? ticketSearchResultPaged.items[0].columns.map((columna: any) => ({
              value: columna.nameData,
              description: columna.nameData,
            }))
          : [];

        this.loadService = false;
        if (this.params['quotationId']) {
          this.params['quotationId'];
          this.getActivityForms(this.params['quotationId']);
        }
      });
  }

  public resetTable(): void {
    this.generalService.goToUrl(['/workflow'], { statusSelected: this.statusSelected }, true);
  }

  // Paginador general
  public onPageChange(page: number): void {
    this.page = page + 1;
    this.getTableModul(this.cotStatusTab?.[this.statusSelected]?.iD_STATUS ?? 0);
  }

  public getActivityForms(quotationId: number): void {
    this.quotationId = quotationId;
    this.viewTable = false;
    this.params = {};
    this.generalService.goToUrl(['/workflow'], { quotationId: this.quotationId }, false);

    const statusId = this.cotStatusTab?.[this.statusSelected]?.iD_STATUS ?? 0;
    this.loadService = true;

    // Ejecutamos ambas peticiones al mismo tiempo
    forkJoin({
      datosRes: this.workflowService.GetDataQuotation(this.quotationId),
      accionesRes: this.workflowService.GetPagesByStatus({ status: statusId }),
    }).subscribe({
      next: ({ datosRes, accionesRes }) => {
        this.loadService = false;

        // 1. Asignamos los datos a su variable original (con fallback a arreglo vacío si es null)
        this.dataQuotation = datosRes ?? [];

        // 2. Verificamos si en los datos viene 'LINEA DE ARRENDAMIENTO'
        const esLineaArrendamiento = this.dataQuotation.some(
          (dato: DataQuotation) => dato.value === 'LINEA DE ARRENDAMIENTO',
        );

        // 3. Procesamos las acciones tipando la variable como PageWorkflow[]
        let accionesFiltradas: PageWorkflow[] = accionesRes ?? [];

        if (esLineaArrendamiento) {
          // Removemos las acciones que no se muestran para linea de arrendamiento
          accionesFiltradas = accionesFiltradas.filter(
            (accion: PageWorkflow) =>
              accion.title !== 'COTIZACION' && accion.title !== 'EDITAR COTIZACION',
          );
        }

        // 4. Asignamos las acciones finales a pageWorkflow
        this.pageWorkflow = accionesFiltradas;
      },
      error: () => {
        this.loadService = false;
      },
    });
  }

  public getTabPagues(page: number): void {
    this.dynamicPageService.emitNewForm.emit({
      idPage: page,
      quotationId: this.quotationId,
    });
  }

  // Cambio de Face
  public changeQuotationStatus(event: {
    description: string;
    icon: string;
    CctStatus: CotStatus;
    status: number;
  }) {
    if (event.status == 1) {
    }
    if (event.status == 2) {
      this.openModalCancelQuotation();
    }
    if (event.status == 3) {
      this.openModalChangeQuotationStatus(event.CctStatus);
    }
    if (event.status == 4) {
      if (this.cotStatusTab![this.statusSelected].iD_STATUS == 15) {
        this.staticPageService.getSTPInitialData(this.quotationId).subscribe((ress) => {
          if (ress && ress.clabE_STP !== '') {
            this.sentEmailModalConfirmClient();
          } else {
            this.migrationUtilityService.getValidations(this.quotationId).subscribe((mess) => {
              if (Array.isArray(mess) && mess.length > 0) {
                this.generateList(true, mess);
                return;
              }
              this.openModalChangeQuotationStatus(event.CctStatus);
            });
          }
        });
      } else {
        this.migrationUtilityService.getValidations(this.quotationId).subscribe((mess) => {
          if (Array.isArray(mess) && mess.length > 0) {
            this.generateList(true, mess);
            return;
          }
          this.openModalChangeQuotationStatus(event.CctStatus);
          // if(this.cotStatus[this.statusSelected].iD_STATUS == 24){
          //   this.sentEmailModalConfirmClient();
          // }
        });
      }
    }
  }

  private generateList(isValid: boolean, body: any) {
    let bodyList: ListDataModalInterface[] = [];
    if (!isValid) {
      bodyList = body.map((item: any) => {
        const { idCotizacion, status, descripcion, ...rest } = item;
        const list = Object.keys(rest).map((key) => `Input: ${key}`);
        return {
          tilte: descripcion,
          list: list,
        };
      });
    } else {
      bodyList = [
        {
          tilte: 'Validaciones',
          list: body.map((item: any) => item.descripcion),
        },
      ];
    }

    this.openModalQuotationValidations(bodyList);
  }

  public openModalQuotationValidations(bodyList: ListDataModalInterface[]): void {
    const isLargeScreen = window.innerWidth > 1200;
    const isMediumScreen = window.innerWidth > 768;
    const modaData: ModalInterface = {
      Titule: 'Validación de Campos',
      buttonClose: true,
      button: 'Cerrar',
      text: 'Los siguientes Campos son requeridos',
      data: {},
      bodyList: bodyList,
    };
    this.dialog.open(ModalGeneralComponent, {
      width: isLargeScreen ? '800px' : isMediumScreen ? '600px' : '70vw',
      height: isLargeScreen ? '600px' : isMediumScreen ? '500px' : '60vh',
      disableClose: true,
      autoFocus: false,
      data: modaData,
    });
  }

  public openModalCancelQuotation(): void {
    const dataAux: ModalCommentInterface = {
      Titule: 'Cancelar Cotización',
      buttonClose: true,
      isRequired: true,
      button: 'Cancelar',
      placeholder: 'Comentario',
      text: 'Estas por cancelar esta cotización: ' + this.quotationId,
    };
    const dialogRef = this.dialog.open(ModalGeneralCommentComponent, {
      width: '500px',
      height: '450px',
      disableClose: true,
      autoFocus: false,
      data: dataAux,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const userId = localStorage.getItem('userId');
        this.migrationUtilityService
          .changeQuotationStatus({
            quotationId: this.quotationId,
            userId: Number(userId),
            newStatus: 'CANCELADO',
            comment: result,
          })
          .subscribe((ress) => {
            this.generalService.viewSnacAlert(
              `Solicitud ${this.quotationId} cancelada`,
              'normal',
              'Cancelada',
            );
            this.generalService.goToUrl(['/workflow'], {}, false);
            this.generalService.goToUrl(['/workflow'], { newLoad: '1' }, false);
          });
      }
    });
  }

  public openModalChangeQuotationStatus(cotStatus: CotStatus): void {
    const dataAux: ModalCommentInterface = {
      Titule: 'Cambio de Fase',
      buttonClose: true,
      isRequired: true,
      button: 'Cambiar Status',
      placeholder: 'Comentario',
      label: 'Comentario',
      text: 'Estas por cambiar de Fase a ' + cotStatus.descripcion,
    };
    const dialogRef = this.dialog.open(ModalGeneralCommentComponent, {
      width: '500px',
      height: '450px',
      disableClose: true,
      autoFocus: false,
      data: dataAux,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const userId = localStorage.getItem('userId');
        this.migrationUtilityService
          .changeQuotationStatus({
            quotationId: this.quotationId,
            userId: Number(userId),
            newStatus: cotStatus.deS_STATUS,
            comment: result,
          })
          .subscribe((ress: any) => {
            if (cotStatus.iD_STATUS == 24) {
              this.generalService.goToUrl(['/active-portfolio'], {}, true);
            } else {
              const indexEncontrado =
                this.cotStatusTab?.findIndex((item) => item.deS_STATUS === cotStatus.deS_STATUS) ??
                -1;
              this.generalService.goToUrl(
                ['/workflow'],
                {
                  statusSelected: indexEncontrado,
                },
                true,
              );
            }
          });
      }
    });
  }

  public emitButtonForm(event: { toll: Toll; formGroups: GeneralForm }): void {
    if (event.toll.function === 'back') {
      this.pageWorkflow = [];
      this.viewTable = true;
    }
  }

  public sentEmailModalConfirmClient(): void {
    const dialogRef = this.dialog.open(ModalGeneralComponent, {
      width: '500px',
      height: 'auto',
      disableClose: true,
      autoFocus: false,
      data: {
        Titule: 'Enviar a mail',
        buttonClose: true,
        button: 'Si',
        buttonCancel: 'No',
        text: '¿Confirma el envio de mail de APROBACIÓN?',
        data: {},
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result !== null) {
        if (result) {
          this.sentEmailConfirmClient();
        } else {
          this.changeQuotationStatusConfirmClient();
        }
      }
    });
  }

  private sentEmailConfirmClient(): void {
    this.loadService = true;
    this.staticPageService.approveQuotationMail(this.quotationId).subscribe((ress: any) => {
      this.changeQuotationStatusConfirmClient();
    });
  }

  private changeQuotationStatusConfirmClient(): void {
    this.loadService = true;
    const userId = localStorage.getItem('userId');
    this.migrationUtilityService
      .changeQuotationStatus({
        quotationId: this.quotationId,
        userId: Number(userId),
        newStatus: 'PARA_NOTIFICACION',
        comment: 'Cambio de face Confirmacion(CONFIRMAR CLIENTE)',
      })
      .subscribe((ress) => {
        if (ress) {
          this.loadService = false;
          this.generalService.viewSnacAlert(
            'Cambio de face Confirmacion',
            'normal',
            'CONFIRMAR CLIENTE',
          );
          this.generalService.goToUrl(['/workflow'], {
            statusSelected: 5,
          });
        }
      });
  }

  get normalizecotPageWorkflow(): TabRouter[] {
    return this.pageWorkflow.map((item, index) => ({
      descripcion: item.title,
      id: item.id,
      indexSelected: item.id,
    }));
  }
}
